module.exports = __webpack_public_path__ + "img/rejected-status.9ff43a3.png";